import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PublicLayout } from "./presentation/layouts/PublicLayout";
import { HomePage } from "./presentation/pages/Home";
import { TermsPage } from "./presentation/pages/Terms";
import { PrivacyPage } from "./presentation/pages/Privacy";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
